export const DB_NAME = 'bc-widget-integration';
